"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactUseIdHook = require("react-use-id-hook");

var _excluded = ["alt", "longAlt", "style"],
    _excluded2 = ["maxWidth"];

function Image(_ref) {
  var alt = _ref.alt,
      longAlt = _ref.longAlt,
      style = _ref.style,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (alt === undefined) {
    throw new Error("Images must have prop 'alt' specified.");
  }

  var id = (0, _reactUseIdHook.useId)();

  var _ref2 = style || {},
      maxWidth = _ref2.maxWidth,
      stylerest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);

  if (longAlt) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", Object.assign({
      alt: alt,
      style: (0, _objectSpread2.default)({
        maxWidth: maxWidth || "100%"
      }, stylerest),
      "aria-describedby": "desc-".concat(id)
    }, props)), /*#__PURE__*/_react.default.createElement("p", {
      id: "desc-".concat(id),
      className: "sr-only"
    }, longAlt));
  }

  return /*#__PURE__*/_react.default.createElement("img", Object.assign({
    alt: alt,
    style: (0, _objectSpread2.default)({
      maxWidth: maxWidth || "100%"
    }, stylerest)
  }, props));
}